import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import { getPaymentBrand } from 'helpers/constants';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { sendBoleto } from 'store/Orbita/Invoice/actions';
import PaymentTypeImg from 'v2/components/Shared/PaymentTypeImg';
import { Space } from 'v2/components/Shared/Space';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any>, StyledComponentProps {
  invoice: any;
  sendBoleto: any;
}

interface IStates {}

class Payment extends React.Component<IProps, IStates> {
  handleSendBoletoEmail = () => {
    (async () => {
      try {
        await this.props.dispatch(sendBoleto(this.props.invoice.id));
        toast.success('Boleto enviado com sucesso!');
      } catch (error) {
        toast.error(error);
      }
    })();
  };

  handlePaymentTitle = (invoice: any): string => {
    if (!invoice) {
      return '';
    }

    if (invoice?.card_brand) {
      return invoice.card_brand;
    }

    return getPaymentBrand(invoice?.payment_method?.name || 'desconhecido').alias;
  };

  render() {
    const { sendBoleto, invoice } = this.props;
    const payments = invoice.payments;
    return (
      <React.Fragment>
        <div className={this.props.classes.rowValues}>
          <h4>Detalhes do pagamento</h4>

          <div className='content__client'>
            {invoice.customer && invoice.customer.name && (
              <React.Fragment>
                {invoice.cart.id && invoice.cart.id > 0 && (
                  <div className='row__client'>
                    <div className='client__title'>Transação</div>
                    {invoice.cart.id}
                  </div>
                )}
                <div className='row__client'>
                  <div className='client__title'>Tipo</div>

                  {invoice.installments && invoice.installments > 0 && invoice.payment_method.name === 'Credito' ? (
                    <>
                      {invoice.installments + 'x'}
                      <Space axis='horizontal' size={4} />
                    </>
                  ) : null}

                  {this.handlePaymentTitle(invoice)}
                  <Space axis='horizontal' size={8} />
                  <PaymentTypeImg invoice={invoice} />
                </div>

                {invoice.bar_code && (
                  <div className='row__client'>
                    <div className='client__title'>Cód. Boleto</div>

                    <CustomCopyToClipboard text={invoice.bar_code} disableUnderline={true} />

                    {invoice && invoice.payment_status && invoice.payment_status.id === 1 && invoice.payment_method.id === 1 && (
                      <Button onClick={this.handleSendBoletoEmail} disabled={sendBoleto && sendBoleto.isFetching} style={{ marginLeft: 5 }}>
                        Enviar Boleto
                        {sendBoleto && sendBoleto.isFetching && <CircularProgress size={19} style={{ marginLeft: 10 }} />}
                      </Button>
                    )}
                  </div>
                )}
                <div className='m16'></div>
                {invoice && invoice.multiple_cards && (
                  <div className={this.props.classes.multiple}>
                    <div className='multiple__title'>
                      <div className='row__card'>Bandeira</div>
                      <div className='row__card'>Valor</div>
                      <div className='row__card'></div>
                      <div className='row__card'></div>
                    </div>
                    <div className='multiple__content'>
                      {payments &&
                        Array.isArray(payments) &&
                        payments.map((pay: any, index: any) => {
                          return (
                            <div key={`key-${index}`} className='multiple__title'>
                              <div className='row__card'>
                                <Tooltip placement='top' title={getPaymentBrand(pay?.brand || 'desconhecido').alias}>
                                  <img
                                    className='my-table__payment'
                                    alt={getPaymentBrand(pay?.brand || 'desconhecido').alias}
                                    src={getPaymentBrand(pay?.brand || 'desconhecido').url}
                                    style={{
                                      margin: '0px 0.5rem 0 0',
                                      width: '1.5rem',
                                      position: 'relative',
                                      top: '-1px',
                                    }}
                                  />
                                </Tooltip>
                              </div>
                              <div className='row__card'>
                                {pay.parcels} x <FormattedNumber value={pay.value} format='BRL' />
                              </div>
                              <div className='row__card'></div>
                              <div className='row__card'></div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    sendBoleto: state.orbita.Invoice.sendBoleto,
  };
}

export default connect(mapStateToProps)(Payment);
